// Whether the anonymous share-reward program is paying this user right now:
// an eligible sharer AND the program in rewards mode (stamped into gon at
// boot). The share buttons on the daily embeds promise "1¢ per view" only
// when this holds; per-link caps are the info tray's fine print.
export function shareRewardsActive(): boolean {
    return typeof gon !== 'undefined' && gon?.anonymousShareRewardsActive === true
}
